<div style="text-align: center">
  <h1 style="font-family: Exo, sans-serif; font-weight: bold; padding-top: 10px" mat-dialog-title>Intervallo somministrazione {{data.questionnaire}}</h1>
  <form class="form" [formGroup]="frequencyForm">
    <div mat-dialog-content style="padding-top: 5px">
      <p>Imposta l'intervallo (da 1 a 365 giorni) per l'invio automatico del questionario.</p>
      <p style="font-weight: bold">Intervallo somministrazione:
      <ng-container *ngIf="data.currentTimer > 0; else noSet">
        {{currentTimer}} {{currentTimer === 1 ? 'giorno' : 'giorni'}}
      </ng-container>
      <ng-template #noSet>
        -
      </ng-template>
      </p>
      <div style="padding-bottom: 5px"></div>
      <mat-form-field appearance="outline">
        <mat-label>Inserisci intervallo</mat-label>
        <input matInput type="number" placeholder="Frequenza" formControlName="frequency" (focusin)="notFocused=false" (focusout)="notFocused=true">
      </mat-form-field>
    </div>
    <div mat-dialog-actions style="justify-content: center;">
      <button mat-raised-button color="primary" [disabled]="!frequencyForm.valid" [mat-dialog-close]="frequencyForm.get('frequency').value">Conferma</button>
      <button mat-raised-button color="warn" (click)="cancel()">Annulla</button>
      <ng-container *ngIf="data.currentTimer > 0">
        <button mat-raised-button color="warn" [mat-dialog-close]="killJob">Elimina esistente</button>
      </ng-container>
    </div>
  </form>
</div>
